<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="Jobs"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <VueSlickgrid
    name="jobs"
    :headerTitle="'Jobs'|pgettext('Jobs')"
    :items="ds"
    checkbox-row-selection
    :columnDefaults="b_2248226175642056_columnDefaults"
    :columns="b_2248226175642056_columns"
    class="page--grid"
    ref="grid"
    @selectedRowsChanged="evh_2248226175642056_selectedRowsChanged($event, {})"
    @command="evh_2248226175642056_command($event, {})"
  >
    <DIV
      class="flex-grow-1 d-flex"
      slot="toolbar"
    >
      <PageHelp
        path="/general/jobs.html"
      >
      </PageHelp>
    </DIV>
  </VueSlickgrid>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

addRoute(
  {
    name: "jobs",
    path: "/jobs",
    component: "Jobs"
  }
)

@Component()
export default class Jobs extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  selectedItems!: any;
  ds!: any;

  async $$load_ds() {
    return this.$fn.slickDataSource('browse_jobs')
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_2248226175642056_columnDefaults!: any;
  b_2248226175642056_columns!: any;
  dataMembers = ['selectedItems', 'ds', 'ux', 'b_7315092382398562_modalBindings', 'b_2248226175642056_columnDefaults', 'b_2248226175642056_columns'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        selectedItems: [
        ]
        ,
        ds: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
        b_2248226175642056_columnDefaults: {
          sortable: true,
          filterable: true,
          resizable: true,
        }
        ,
        b_2248226175642056_columns: [{
          field: "number",
          name: this.$fn.pgettext("Jobs", "Number"),
          type: "command",
          formatter: [{
            name: "template",
            format: "#{{ number }}",
          }
            ,
          {
            name: "link",
            href: "#",
          }
            ,
          ]
          ,
        }
          ,
        {
          field: "status",
          name: this.$fn.pgettext("Jobs", "Status"),
          formatter: {
            name: "chain",
            formatters: [{
              name: "gettext",
              context: "JobStatus",
            }
              ,
            {
              name: "cellclass",
              options: {
                Running: "bg-warning-light",
                "Errored/Rerunning": "bg-warning-light",
                Errored: "bg-danger-light",
                Failed: "bg-danger-light",
                Completed: "bg-success-light",
              }
              ,
              optionsSource: "fieldValue",
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "job_type",
          name: this.$fn.pgettext("Jobs", "Job type"),
        }
          ,
        {
          field: "created_by",
          name: this.$fn.pgettext("Jobs", "User"),
          formatter: {
            name: "user",
          }
          ,
        }
          ,
        {
          field: "created_at",
          name: this.$fn.pgettext("Jobs", "Submit time"),
          formatter: {
            name: "datetime",
          }
          ,
        }
          ,
        ]
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.gettext("Jobs"),
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_4308_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_4308, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_setData_4310_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_2248226175642056_setData_4310, alias=undefined
    return {
      path: "selectedItems",
      value: this.$refs.grid.getSelectedItems(),
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_2248226175642056_selectedRowsChanged(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_selectedRowsChanged.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_showModal_4312_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_2248226175642056_showModal_4312, alias=undefined
    return {
      name: "DunningLetter",
      props: {
        id: $event.data.data.job_data.id,
      }
      ,
    }
  }

  async evh_2248226175642056_command_4311_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_2248226175642056_command_4311, alias=undefined
    return $event.data.column.id === 'job_data'
  }

  async act_2248226175642056_showModal_4314_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_2248226175642056_showModal_4314, alias=undefined
    return {
      name: "JobModal",
      props: {
        id: $event.data.data.id,
      }
      ,
    }
  }

  async evh_2248226175642056_command_4313_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_2248226175642056_command_4313, alias=undefined
    return $event.data.column.id === 'number'
  }

  async evh_2248226175642056_command(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_command.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_4308: actions.CloseModalAction;
    evh_7315092382398562_close_4307: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_setData_4310: actions.SetDataAction;
    evh_2248226175642056_selectedRowsChanged_4309: actions.EventHandlerImpl;
    evh_2248226175642056_selectedRowsChanged: actions.EventHandlerGroup;
    act_2248226175642056_showModal_4312: actions.ShowModalAction;
    evh_2248226175642056_command_4311: actions.EventHandlerImpl;
    act_2248226175642056_showModal_4314: actions.ShowModalAction;
    evh_2248226175642056_command_4313: actions.EventHandlerImpl;
    evh_2248226175642056_command: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_4308 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_4308_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_4307 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_4308,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_4307],
      }
    );
    const act_2248226175642056_setData_4310 = new actions.SetDataAction(
      {
        actionArgs: this.act_2248226175642056_setData_4310_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_selectedRowsChanged_4309 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_setData_4310,
        event: "selectedRowsChanged",
        displayName: "setData",
      }
    );
    const evh_2248226175642056_selectedRowsChanged = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_selectedRowsChanged_4309],
      }
    );
    const act_2248226175642056_showModal_4312 = new actions.ShowModalAction(
      {
        actionArgs: this.act_2248226175642056_showModal_4312_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_command_4311 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_showModal_4312,
        event: "command",
        when: this.evh_2248226175642056_command_4311_getWhen,
        displayName: "showModal",
      }
    );
    const act_2248226175642056_showModal_4314 = new actions.ShowModalAction(
      {
        actionArgs: this.act_2248226175642056_showModal_4314_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_command_4313 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_showModal_4314,
        event: "command",
        when: this.evh_2248226175642056_command_4313_getWhen,
        displayName: "showModal",
      }
    );
    const evh_2248226175642056_command = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_command_4311, evh_2248226175642056_command_4313],
      }
    );
    return {
      act_7315092382398562_closeModal_4308,
      evh_7315092382398562_close_4307,
      evh_7315092382398562_close,
      act_2248226175642056_setData_4310,
      evh_2248226175642056_selectedRowsChanged_4309,
      evh_2248226175642056_selectedRowsChanged,
      act_2248226175642056_showModal_4312,
      evh_2248226175642056_command_4311,
      act_2248226175642056_showModal_4314,
      evh_2248226175642056_command_4313,
      evh_2248226175642056_command,
    }
  }
}

Vue.component("Jobs", Jobs);

</script>